import { isPresent, isNotEmpty } from "neetocist";

import currencyData from "./currencyData.json";

export const getCurrencies = allowedCurrencies => {
  if (isPresent(allowedCurrencies) && isNotEmpty(allowedCurrencies)) {
    return currencyData.filter(item => allowedCurrencies.includes(item.value));
  }

  return currencyData;
};
